import React, { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { FormComponent } from 'components';
import { EVENT_MENU_URL } from 'data/menu';
import { useInfiniteScroll } from 'hooks';
import { EventQuery } from 'queries';
import { IEvent, SearchEventFilterType } from 'types';
import { getEventStatus, getEventStatusTone } from '../utils';
import * as M from 'styles/mobile';
import * as S from './style';

const DATE_FORMAT = 'YYYY.MM.DD HH:mm';

const formatRange = (start: string, end: string) =>
  `${dayjs(start).format(DATE_FORMAT)} ~ ${dayjs(end).format(DATE_FORMAT)}`;

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<SearchEventFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    EventQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const events: IEvent[] = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchEventFilterType) =>
            setFilter({ title: d.title || undefined })
          }
        >
          <FormComponent.SearchInput
            name="title"
            placeholder="봉사명으로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {events.map((event) => {
          const status = getEventStatus(
            event.eventStatus,
            event.startDate,
            event.endDate,
            event.enrollStartDate,
            event.enrollEndDate,
          );
          return (
            <button
              key={event.id}
              type="button"
              css={M.listItem}
              onClick={() => navigate(`${EVENT_MENU_URL.행사}/${event.id}`)}
            >
              <div css={[M.listRow, S.titleRow]}>
                <div css={S.titleWrap}>
                  <p css={S.title}>{event.title}</p>
                  <span css={[M.tag(getEventStatusTone(status)), S.tagOffset]}>
                    {status}
                  </span>
                </div>
                <span css={[M.listDate, S.dateOffset]}>
                  {dayjs(event.createdAt).format('YYYY-MM-DD')}
                </span>
              </div>
              <dl css={S.period}>
                <dt>모집기간</dt>
                <dd>
                  {formatRange(event.enrollStartDate, event.enrollEndDate)}
                </dd>
              </dl>
              <dl css={S.period}>
                <dt>봉사일시</dt>
                <dd>{formatRange(event.startDate, event.endDate)}</dd>
              </dl>
            </button>
          );
        })}
        {!isLoading && events.length === 0 && (
          <p css={M.empty}>검색 결과가 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
